import TabsList from "molecules/TabsList";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import { getMenuList, getUserRoleId } from "redux/selectors";
import LeaveApproval from "./LeaveApproval";
import TimeSheetApproval from "./TimeSheet/TimeSheetApproval";
import BillingApproval from "./Engagement/Billing/BillingApprovals";
import PFAApproval from "./Engagement/AddNewEngagement/PFAApproval";
import FundRequestApproval from "./Engagement/AddNewEngagement/FundApproval";
import MatterApproval from "./Engagement/AddNewEngagement/MatterApproval"; // adjust path as needed

const Approval = ({ menuList, userRoleId }) => {
  let Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;

  Menulist = Array.isArray(Menulist) ? Menulist : [];

  const timeSheetMenu = Menulist.find(
    (item) => item.key === "timesheetapprovals"
  );

  const leaveApprovalAccess = Menulist.find(
    (item) => item.key === "approvals"
  )?.access;

  const timeSheetApprovalAccess = timeSheetMenu?.access;

  const billingApprovalAccess = Menulist.find(
    (item) => item.key === "billingapprovals"
  )?.access;

  const timeSheetPermission = timeSheetMenu?.permission;
  const pfaapprovalaccess = Menulist?.find(
    (item) => item.key === "PFAapprovals" && item.access
  );
  const fundapprovalaccess = Menulist?.find(
    (item) => item.key === "PFAapprovals" && item.access
  );

  // NEW: matter approvals access lookup — adjust "key" to match your actual menu config
  const matterApprovalMenu = Menulist.find(
    (item) => item.key === "matterrequest"
  );
  const matterApprovalAccess = matterApprovalMenu?.access;
  const matterApprovalPermission = matterApprovalMenu?.permission;

  const pfaapprovalpermission = pfaapprovalaccess?.permission;
  const fundapprovalpermission = fundapprovalaccess?.permission;

  const { state } = useLocation();
  const [tabId, setTabId] = useState(state?.tabId || "leave_approvals");

  const handleTabSelect = (id) => {
    setTabId(id);
  };

  useEffect(() => {
    if (leaveApprovalAccess) {
      setTabId("leave_approvals");
    } else if (timeSheetApprovalAccess) {
      setTabId("timesheet_approvals");
    } else if (billingApprovalAccess) {
      setTabId("billing_approval");
    } else if (matterApprovalAccess) {
      setTabId("matter_approval");
    }
  }, [
    leaveApprovalAccess,
    timeSheetApprovalAccess,
    billingApprovalAccess,
    matterApprovalAccess,
  ]);

  useEffect(() => {
    if (state?.tabId) {
      setTabId(state.tabId);
    }
  }, [state]);

  const approvalTabs = useMemo(
    () => [
      leaveApprovalAccess
        ? {
          id: "leave_approvals",
          label: "Leave Approvals",
          component: <LeaveApproval />,
        }
        : null,
      timeSheetApprovalAccess
        ? {
          id: "timesheet_approvals",
          label: "Timesheet Approvals",
          component: (
            <TimeSheetApproval timeSheetPermission={timeSheetPermission} />
          ),
        }
        : null,
      billingApprovalAccess
        ? {
          id: "billing_approval",
          label: "Billing Approvals",
          component: (
            <BillingApproval timeSheetPermission={timeSheetPermission} />
          ),
        }
        : null,
      pfaapprovalaccess
        ? {
          id: "pfa_approval",
          label: "PFA Approval",
          component: (
            <PFAApproval pfaapprovalpermission={pfaapprovalpermission} />
          ),
        }
        : null,
      fundapprovalpermission
        ? {
          id: "fund_approval",
          label: "Fund Request Approval",
          component: (
            <FundRequestApproval
              pfaapprovalpermission={fundapprovalpermission}
            />
          ),
        }
        : null,
      // NEW: Matter Approvals tab
      matterApprovalAccess
        ? {
          id: "matter_approval",
          label: "Matter Approvals",
          component: (
            <MatterApproval matterApprovalPermission={matterApprovalPermission} />
          ),
        }
        : null,
    ].filter(Boolean),
    [
      leaveApprovalAccess,
      timeSheetApprovalAccess,
      timeSheetPermission,
      billingApprovalAccess,
      pfaapprovalaccess,
      pfaapprovalpermission,
      matterApprovalAccess,
      matterApprovalPermission,
    ]
  );

  return (
    <div>
      <TabsList
        items={approvalTabs}
        handleTabSelect={handleTabSelect}
        tabId={tabId}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
});

export default connect(mapStateToProps, null)(Approval);